import { render, staticRenderFns } from "./CjUpload.vue?vue&type=template&id=442a959a&"
import script from "./CjUpload.vue?vue&type=script&lang=js&"
export * from "./CjUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports